// AbortController was introduced quite a while after fetch and
// isnt required for PouchDB to function so polyfill if needed
var a = (typeof AbortController !== 'undefined')
    ? AbortController
    : function () { return {abort: function () {}}; };

var f = fetch;
var h = Headers;

export { f as fetch, h as Headers, a as AbortController };



//////////////////
// WEBPACK FOOTER
// ./node_modules/pouchdb-fetch/lib/index-browser.es.js
// module id = 43
// module chunks = 0